module.exports = __webpack_public_path__ + "img/lobby_waiting_room.f79828e6.png";